import { useRef, type PropsWithChildren, type ReactNode } from "react";
import { cn } from "@/lib/utils";
import { toolbarTier } from "./document-toolbar/documentToolbarTiers";
import { useToolbarTier } from "./document-toolbar/useToolbarTier";

type DocumentViewerToolbarProps = PropsWithChildren<{
  timeline?: ReactNode;
}>;

/**
 * Two-row document chrome: optional timeline row, then the controls row.
 *
 * The controls row owns the toolbar's tier: it measures how much of the bar
 * fits and marks itself so the groups inside fold accordingly. The groups
 * themselves are the children — a header component contributes them and
 * nothing else.
 */
export const DocumentViewerToolbar = ({
  timeline,
  children,
}: DocumentViewerToolbarProps) => {
  const rowRef = useRef<HTMLDivElement>(null);
  const barRef = useRef<HTMLDivElement>(null);
  useToolbarTier(rowRef, barRef, Boolean(children));

  return (
    <>
      {timeline && (
        <div className="border-b px-4 sm:px-6 min-w-0 overflow-hidden">
          {timeline}
        </div>
      )}
      {children ? (
        <div
          ref={rowRef}
          className={cn(
            "min-w-0 overflow-hidden px-4 py-2 sm:px-6",
            toolbarTier.group
          )}
        >
          <div
            ref={barRef}
            className={cn(
              "flex w-full min-w-0 items-center gap-2 text-xs",
              toolbarTier.barWrap
            )}
          >
            {children}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default DocumentViewerToolbar;
